exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lift-picker{max-height:240px;overflow-y:auto;border:1px solid #ced4da;border-radius:4px;padding:4px}.lift-picker-item{display:flex;align-items:center;gap:8px;padding:4px 8px;border-radius:3px;cursor:pointer;margin:0;font-weight:400;user-select:none}.lift-picker-item:hover{background-color:#f0f4ff}.lift-picker-item.selected{background-color:#e8f0fe}.lift-picker-item input[type=checkbox]{margin:0;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72b3dabd","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Groups.vue
// module id = 850
// module chunks = 0